import React from 'react'
import { inject, observer } from 'mobx-react'

import UsersTableActions from './UsersTableActions'
import TagList from '../../../generic/TagList'
import Table from '../../../generic/Table'
import Loader from '../../../generic/Loader'

const UsersTable = inject('configUsersStore')(observer(props => {
  const { configUsersStore } = props
  const { users, isFetching } = configUsersStore.state
  const tableHeaders = ['Nome', 'Email', 'Telefone', 'Empresas', 'Grupos', '']
  const tableRows = users.map(data => {
    const companyTags = data.dados.companies.map(data => {
      return {
        text: data
      }
    })
    const profileTags = data.dados.profiles.map(data => {
      return {
        text: data
      }
    })
    return [
      data.dados.name,
      data.dados.email,
      data.dados.phoneNumber,
      <TagList tags={companyTags} />,
      <TagList tags={profileTags} />,
      <UsersTableActions user={data.dados} />
    ]
  }).sort((current, next) => current[0].localeCompare(next[0]))
  return (
    <Loader isLoading={isFetching}>
      <Table rows={tableRows} headers={tableHeaders} />
    </Loader>
  )
}))

export default UsersTable



// WEBPACK FOOTER //
// ./src/components/dashboard/config/users/UsersTable.js